module.exports = __webpack_public_path__ + "img/logo.7655e4cf.png";